<template>
  <div class="product-slide">
    <div class="content-block__swiper__slide">
      <NuxtLink
        :to="
          localePath({
            name: 'product-slug',
            params: { slug: item.slug },
          })
        "
      >
        <div
          v-if="item.portrait.length"
          class="content-block__swiper__slide__image"
        >
          <WidgetPicture
            :image="{
              portrait: item.portrait?.[0],
            }"
            :alt="item.portrait?.[0]?.title"
          />
        </div>
        <div class="content-block__swiper__slide__text">
          <div
            v-if="item?.title"
            class="content-block__swiper__slide__title title-base3"
          >
            <p v-html="item.title" />
          </div>
          <div
            v-if="item.sezioneBio && item.sezioneBio.length"
            class="content-block__swiper__slide__bio text-xsmall"
          >
            <span
              v-for="(item, index) in item.sezioneBio"
              :key="index"
              v-html="$t('product.' + item)"
            />
          </div>
          <div
            class="content-block__swiper__slide__stili-adatto-per text-xsmall"
            v-if="filtroList && filtroList.length"
          >
            <p>{{ label }}:&nbsp;&nbsp;</p>
            <p v-for="(item, index) in filtroList" :key="index" class="item">
              {{ formattedItemTitle(item)
              }}<span v-if="index < filtroList.length - 1">,&nbsp;</span>
            </p>
          </div>
          <div
            v-if="localizedDescrizioneProdotto"
            class="content-block__swiper__slide__description text-xsmall"
          >
            <div v-html="shortDescrizioneProdotto" />
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { useProductDetails } from '~/composables/product-details.js'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})

// Vino adatto per / Stili birra
const { typeHandle, filtroTipologiaVino, filtroStiliBirra } = props.item
const { filtroList, itemPrefix, label } = useProductDetails({
  typeHandle,
  filtroTipologiaVino,
  filtroStiliBirra,
})

// Traduzioni per campi-testo del prodotto in base alla lingua
const { locale } = useI18n()
const getLocalizedField = (field) => {
  switch (locale.value) {
    case 'en':
      return props.item[`${field}En`]
    case 'es':
      return props.item[`${field}Es`]
    case 'fr':
      return props.item[`${field}Fr`]
    default:
      return props.item[field]
  }
}

const localizedDescrizioneProdotto = computed(() =>
  getLocalizedField('descrizioneProdotto'),
)

const shortDescrizioneProdotto = computed(() => {
  const descrizione = localizedDescrizioneProdotto.value || ''
  const parts = descrizione.split('.')
  if (parts.length > 2) {
    return parts.slice(0, 2).join('.') + '.'
  } else if (parts.length > 1) {
    return parts.slice(0, 1).join('.') + '.'
  } else {
    return descrizione
  }
})

const formattedItemTitle = (item) => {
  return locale.value === 'en'
    ? `${item.title} ${itemPrefix.value}`
    : `${itemPrefix.value} ${item.title}`
}
</script>

<script>
export default {
  name: 'ProductSlide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
